"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Constants = require("../../00_environment/Constants");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _Bottom = _interopRequireDefault(require("../../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _Element = _interopRequireDefault(require("../../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../../01_atoms/ElementGroup"));

var _BlockWithLeftIcon = _interopRequireDefault(require("../../01_atoms/BlockWithLeftIcon"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _tick = _interopRequireDefault(require("../../../assets/tick.svg"));

var _boy = _interopRequireDefault(require("../../../assets/boy.svg"));

var _bookingPending = _interopRequireDefault(require("../../../assets/booking-pending.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BookingConfirmedUI = function BookingConfirmedUI(_ref) {
  var _ref$pending = _ref.pending,
      pending = _ref$pending === void 0 ? false : _ref$pending,
      createAccountLink = _ref.createAccountLink,
      viewTicketsLink = _ref.viewTicketsLink,
      loggedIn = _ref.loggedIn,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('BookingConfirmedUI');
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: pending ? t('Order in process') : t('Order confirmed')
  }, pending && /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t('Your payment was successful')
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, /*#__PURE__*/_react["default"].createElement(_BlockWithLeftIcon["default"], {
    icon: _bookingPending["default"]
  }, /*#__PURE__*/_react["default"].createElement("strong", null, t('We are now confirming your order with the Bus company.')), /*#__PURE__*/_react["default"].createElement("br", null), t('This process can take a few hours.'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t("We'll send you an e-mail with your bus tickets once your order is confirmed."), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('Stay tuned!')))), !pending && /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t('Your payment was successful')
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, /*#__PURE__*/_react["default"].createElement(_BlockWithLeftIcon["default"], {
    icon: _tick["default"]
  }, t('Your order is validated'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('We sent you an e-mail with your order details and your bus tickets.'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('Have a nice trip!')))), !loggedIn && /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t('Save some time next time')
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, /*#__PURE__*/_react["default"].createElement(_BlockWithLeftIcon["default"], {
    icon: _boy["default"]
  }, t('Be smart:'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('Save your payment and passenger details by creating a free {appName} account.', {
    appName: _Constants.appName
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: 15
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: createAccountLink,
    primary: true,
    fluid: true
  }, t('Create your free account'))))), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: viewTicketsLink,
    primary: loggedIn,
    fluid: true
  }, t('View my order')))));
};

var _default = BookingConfirmedUI;
exports["default"] = _default;